export default __webpack_public_path__ + "static/media/LAS0740.34I-36956_-24874_0.a4dd9874.jpg";